"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _SkipLinkConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-concur_android.css") : void 0);
var _SkipLinkConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-concur_default.css") : void 0);
var _SkipLinkConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-concur_gateway.css") : void 0);
var _SkipLinkConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-concur_ios.css") : void 0);
var _SkipLinkSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_fiori_3_dark.css") : void 0);
var _SkipLinkSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_fiori_3_hcb.css") : void 0);
var _SkipLinkSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_fiori_3_hcw.css") : void 0);
var _SkipLinkSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_fiori_3.css") : void 0);
var _SkipLinkSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_horizon_dark.css") : void 0);
var _SkipLinkSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_horizon_hcb.css") : void 0);
var _SkipLinkSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_horizon_hcw.css") : void 0);
var _SkipLinkSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./SkipLink-sap_horizon.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var styles = {
  concur_android: _SkipLinkConcur_android.default,
  concur_default: _SkipLinkConcur_default.default,
  concur_gateway: _SkipLinkConcur_gateway.default,
  concur_ios: _SkipLinkConcur_ios.default,
  sap_fiori_3_dark: _SkipLinkSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _SkipLinkSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _SkipLinkSap_fiori_3_hcw.default,
  sap_fiori_3: _SkipLinkSap_fiori_.default,
  sap_horizon_dark: _SkipLinkSap_horizon_dark.default,
  sap_horizon_hcb: _SkipLinkSap_horizon_hcb.default,
  sap_horizon_hcw: _SkipLinkSap_horizon_hcw.default,
  sap_horizon: _SkipLinkSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-skip-link';
var SkipLink = (0, _reactUiTheming.withThemeStyles)(styles)( /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var className = props.className,
    classNameMap = props.classNameMap,
    url = props.url,
    label = props.label,
    linkProps = __rest(props, ["className", "classNameMap", "url", "label"]);
  var classnames = _bind.default.bind(classNameMap);
  return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _assign.default)({}, linkProps, {
    className: classnames(CSS_BLOCK, className),
    href: url,
    ref: ref
  }), label);
}));
SkipLink.displayName = 'SkipLink';
var _default = SkipLink;
exports.default = _default;